import React, { Component, useState } from "react";

export const DocumentInputRow = (props) => {
    const [uploadedFile, updateFileUploaded] = useState(null);
    const [docTypeInput, updateDocTypeInput] = useState(null);

    var documentInput = props.inputFor + "[" + props.id + "].documents";
    var documentInputId = "Document" + props.id + "_" + props.length;
    var documentType = props.inputFor + "[" + props.id + "].documentTypes";

    const docTypeInputTemplate = () => {
        return(
            <div className="col-6">
                <label className="control-label text-muted">Document type</label>
                <select name={documentType} className="form-select" defaultValue="Title">
                    {/* MAPS TO: Vehicle.cs > VehicleView > allowedDocumentTypes */}
                    <option value="Title">Full Car Title</option>,
                    <option value="Title_Front">Front of title</option>,
                    <option value="Title_Back">Back of title</option>
                    <option value="Other">Other Document</option>
                </select>
            </div>
        )
    }

    return(
        <div className="card border border-black p-1">
            <div className="row form-group">   
                {docTypeInput}                
                <div className="col-6 my-auto">
                    <div className="row">   
                        <div className="col-12">
                            <div className="form-file">
                                <input type="file" className="form-file-input" id={documentInputId} name={documentInput}
                                    onChange={(evt) => {
                                        updateFileUploaded(evt.target.value.split("\\").pop());
                                        updateDocTypeInput(docTypeInputTemplate);
                                        props.onFileAdded()
                                    }}/>
                                <label className="form-file-label" htmlFor={documentInputId} >
                                        <button type="button" className="form-file-button btn-dark">Choose file</button>
                                </label>
                            </div>
                        </div>
                        <div className="col-12 text-truncate">                            
                            {uploadedFile}
                        </div>
                    </div>                        
                </div>
            </div>
        </div>
    );

}